import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { RepeatArrowIcon } from '@setup/svg-icons/svg-icons';
import { maintenanceStubConfig } from '@shared/configs/stub.config';
import { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import useAnalyticsEventTracker from '@shared/hooks/analytics/useAnalyticsEventTracker';
import { Stub } from 'shared/ui-kit';

import { MaintenanceStubContainer } from './MaintenanceStub.style';

export const MaintenanceStub = () => {
  const { t } = useTranslation();
  const gaEventTracker = useAnalyticsEventTracker();

  const handleReload = () => {
    window.location.reload();
  };

  useEffect(() => {
    gaEventTracker({
      event: AnalyticsEventEnum.maintenanceStubShowed,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MaintenanceStubContainer>
      <Stub
        config={maintenanceStubConfig}
        buttonProps={{
          label: t('general.buttons.tryAgain'),
          endIcon: <RepeatArrowIcon />,
          onClick: handleReload,
        }}
      />
    </MaintenanceStubContainer>
  );
};
